// src/modules/goldVault/routes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PurchaseLedger from './pages/PurchaseLedger';
import BranchVaultDashboard from './pages/BranchVaultDashboard';
import TransferCreate from './pages/TransferCreate';
import TransferList from './pages/TransferList';
import TransferDetail from './pages/TransferDetail';
import HOVaultDashboard from './pages/HOVaultDashboard';
import TransferApprovals from './pages/TransferApprovals';
import TransferReceipts from './pages/TransferReceipts';
import VaultReconciliation from './pages/VaultReconciliation';
import InventoryAging from './pages/InventoryAging';
import InventoryExplorer from './pages/InventoryExplorer';
import InventoryTimeline from './pages/InventoryTimeline';
import VaultAuditLog from './pages/VaultAuditLog';

function GoldVaultRoutes() {
  return (
    <Routes>
      {/* Branch User */}
      <Route path="purchase-ledger" element={<PurchaseLedger />} />
      <Route path="purchase-ledger/:caseType/:caseId" element={<PurchaseLedger />} />
      <Route path="branch-vault" element={<BranchVaultDashboard />} />

      {/* Transfers */}
      <Route path="transfers" element={<TransferList />} />
      <Route path="transfers/create" element={<TransferCreate />} />
      <Route path="transfers/:id" element={<TransferDetail />} />

      {/* HO User */}
      <Route path="ho-vault" element={<HOVaultDashboard />} />
      <Route path="transfer-approvals" element={<TransferApprovals />} />
      <Route path="transfer-receipts" element={<TransferReceipts />} />
      <Route path="reconciliation" element={<VaultReconciliation />} />
      <Route path="aging" element={<InventoryAging />} />
      <Route path="explorer" element={<InventoryExplorer />} />

      {/* Timeline */}
      <Route path="timeline/:caseId/:caseType" element={<InventoryTimeline />} />

      {/* Audit Log */}
      <Route path="audit-log" element={<VaultAuditLog />} />

      {/* Default */}
      <Route index element={<Navigate to="branch-vault" replace />} />
      <Route path="*" element={<Navigate to="branch-vault" replace />} />
    </Routes>
  );
}

export default GoldVaultRoutes;
